var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{attrs:{"dense":"","items":_vm.items,"small-chips":"","label":_vm.$t('selectGuards'),"hint":_vm.$t('selectGuardsHint'),"persistent-hint":"","item-text":"display","hide-no-data":"","hide-selected":"","multiple":"","menu-props":{
    closeOnClick: true,
    closeOnContentClick: true,
    openOnClick: false
  }},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
  var selected = ref.selected;
  var item = ref.item;
return [_c('v-chip',{attrs:{"selected":selected,"close":"","small":""},on:{"input":function($event){return _vm.remove(item)}}},[_vm._v(" "+_vm._s(item.display)+" ")])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}
var staticRenderFns = []

export { render, staticRenderFns }